import React from 'react';

import CommonRadioButton from '../common-radio-button/CommonRadioButton';

import './CommonRadioGroup.scss';

function CommonRadioGroup({ value: valueProps, onChange, options }) {
  return (
    <div className='common-radio-group'>
      {options.map(({ value, label, disabled }) => (
        <CommonRadioButton
          key={value}
          value={value}
          label={label}
          disabled={disabled}
          isActive={valueProps === value}
          onSelect={onChange}
        />
      ))}
    </div>
  );
}

export default CommonRadioGroup;
